export default __webpack_public_path__ + "static/media/tw.ffa7ef77.svg";